import { __decorate } from "tslib";
import { injectable } from 'inversify';
import { getFieldApi } from '@cores/apis/workspace_api/custom_field';
let GetLayerFieldServiceImpl = class GetLayerFieldServiceImpl {
    getLayerField(fieldId) {
        // @ts-ignore
        return getFieldApi({ field_id: fieldId, need_count: true }).then((res) => {
            return {
                // @ts-ignore
                name: res.field_name, nodeCount: res.field_layer_length, usageCount: res.field_layer_count,
            };
        });
    }
};
GetLayerFieldServiceImpl = __decorate([
    injectable()
], GetLayerFieldServiceImpl);
export { GetLayerFieldServiceImpl };
